export default "__VITE_ASSET__NPPk$0XO__"